module.exports = __webpack_public_path__ + "img/s4Model4.e759a55f.svg";